// img src路径为null或者src路径不存在，展示默认展示图片
const img = {
  bind: function (el, binding) {
    const { value } = binding;
    const defImg = "https://www.xctpt.com/rimp/front/common/empty-img.png";
    if (value) {
      el.setAttribute("src", value);
    } else {
      el.setAttribute("src", defImg);
    }
    el.setAttribute("onerror", `this.src='${defImg}';this.onerror=null`);
  },
};
const install = function (Vue) {
  Vue.directive("img", img);
};

if (window.Vue) {
  window["img"] = img;
  Vue.use(install); // eslint-disable-line
}

export default install;
